
import {
    defineComponent,
    ref,
    onMounted
} from 'vue'
import {
    useRoute
} from 'vue-router';
//components
import SportList from "./pages/Sports.vue"
import btnBack from "@/components/buttons/btnBack.vue"

//services
import eventService from "@/core/services/EventService";
import {
    errManager,
    dateParticipate
} from "@/core/config/Tools";

export default defineComponent({
    name: "EventManager",
    components: {
        SportList, btnBack
    },
    setup() {
        const route = useRoute();
        const {
            id
        } = route.params
        const loader = ref(false)
        const evento = ref( < any > {})
        const activeIndex = ref('0')

        //detalle del evento
        const getDetails = async () => {
            loader.value = true
            await eventService.getDetails(`${id}?type=idevent&list=false`)
                .then((res) => {
                    evento.value = res.data
                    loader.value = false
                }).catch(({
                    response
                }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        onMounted(() => {
            getDetails();
        })

        return {
            id,
            evento,
            loader,
            dateParticipate,
            activeIndex,
            //events
            getDetails

        }

    },
})
